import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
@Injectable({ providedIn: 'root' })
export class NotifyMoveToSharedVaultService {
  private subject = new Subject<void | any>();

  sendMessage(message: any, data: any, index: any) {
    this.subject.next({
      text: message,
      data: data,
      index: index,
    });
  }

  clearMessages() {
    this.subject.next(null);
  }

  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }
}
